/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { adressePrecisionSchema } from "./adressePrecisionSchema.ts";
import { z } from "zod";

/**
 * @description Adresse proposée par le géocodeur de la Base Adresse Nationale.
 */
export const adresseSuggestionSchema = z.object({
      "label": z.string().describe("Libellé complet affiché dans la liste de suggestions."),
  "numero": z.string().describe("Numéro dans la voie, absent quand la suggestion est une voie ou une commune.").optional(),
  "voie": z.string().describe("Nom de la voie (ou du lieu-dit), absent quand la suggestion est une commune.").optional(),
  "codePostal": z.string(),
  "ville": z.string(),
  "codeInsee": z.string().describe("Code INSEE de la commune (`citycode`), clé de `/quartiers`."),
  "latitude": z.number(),
  "longitude": z.number(),
  "precision": z.lazy(() => adressePrecisionSchema).describe("Niveau de précision de la suggestion, tel que renvoyé par le géocodeur (`type`) :\nnuméro dans la voie, voie, lieu-dit, ou commune (utile comme repli GPS d'un bien rural).\n")
      }).describe("Adresse proposée par le géocodeur de la Base Adresse Nationale.")